export const arrowMenuOpen = `<svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.75017 0.500124L2.75017 16.5001L0 16.5001L-1.39876e-06 0.500124L2.75017 0.500124ZM16.501 9.83346L13.0619 13.1668L15.1246 15.1668L22 8.50012L15.1246 1.83346L13.0619 3.83346L16.4997 7.16679L5.49897 7.16679L5.49897 9.83346L16.501 9.83346Z" fill="white"/>
</svg>
`;